//----------- equal height  ---------------- //
jQuery(document).ready(function($) {
	var container = $('.equal-height');
	var items = $('.equal-height .item');

	function equalHeight(group) {
		tallest = 0;
		group.each(function() {
			thisHeight = $(this).outerHeight(true);
			if(thisHeight > tallest) {
				tallest = thisHeight;
			}
		});
		if(tallest > 0){
			group.each(function(index, el) {
				$(this).css('min-height', tallest+'px');
			});
		}
		
		
	}

	function clearHeight() {
		items.css('min-height', '0px');
	}


	function setEqualHeight(){
		if(window.innerWidth > 768){
			container.each(function(index, el) {
				var items = $(this).find('.item');
				equalHeight(items);	
			});
		}else{
			clearHeight();
		}

	}

	setTimeout(setEqualHeight, 0);

	$(window).resize(function() {
		clearHeight();
		setEqualHeight();
	});
});//fin ready

